export const ACTIVITY_STATUS = {
    '未开始': {
        name: '未开始',
        color: 'rgba(166, 166, 166, 1)'
    },
    '进行中': {
        name: '进行中',
        color: 'rgba(10, 136, 255, 1)'
    },
    '已完成': {
        name: '已完成',
        color: 'rgba(10, 136, 255, 1)'
    },
    '已过期': {
        name: '已过期',
        color: 'rgba(237, 133, 133, 1)'
    }
}
export const EMOTION_ARR= [
    {
        label: '不安全',
        value: '',
    },
    {
        label: '紧张',
        value: '',
    },
    {
        label: '恐惧',
        value: '',
    },
    {
        label: '担忧',
        value: '',
    },
    {
        label: '震惊',
        value: '',
    },
    {
        label: '焦虑',
        value: '',
    },
    {
        label: '胆怯',
        value: '',
    },
    {
        label: '怀疑',
        value: '',
    },
    {
        label: '崩溃',
        value: '',
    },
    {
        label: '紧绷',
        value: '',
    },
    {
        label: '疑神疑鬼',
        value: '',
    },
    {
        label: '困惑',
        value: '',
    },
    {
        label: '喜悦',
        value: '',
    },
    {
        label: '欢乐',
        value: '',
    },
    {
        label: '欢喜',
        value: '',
    },
    {
        label: '辛福',
        value: '',
    },
    {
        label: '开心',
        value: '',
    },
    {
        label: '愉悦',
        value: '',
    },
    {
        label: '满足',
        value: '',
    },
    {
        label: '满心喜悦',
        value: '',
    },
    {
        label: '欣喜',
        value: '',
    },
    {
        label: '兴趣十足',
        value: '',
    },
    {
        label: '兴奋',
        value: '',
    },
    {
        label: '激情四射',
        value: '',
    },
    {
        label: '骄傲',
        value: '',
    },
    {
        label: '有力量',
        value: '',
    },
    {
        label: '有价值',
        value: '',
    },
    {
        label: '尊重',
        value: '',
    },
    {
        label: '值得',
        value: '',
    },
    {
        label: '无畏',
        value: '',
    },
    {
        label: '重要',
        value: '',
    },
    {
        label: '决心',
        value: '',
    },
    {
        label: '赋能',
        value: '',
    },
    {
        label: '豁达',
        value: '',
    },
    {
        label: '灵活',
        value: '',
    },
    {
        label: '自信',
        value: '',
    },
    {
        label: '暴怒',
        value: '',
    },
    {
        label: '烦躁',
        value: '',
    },
    {
        label: '苦闷',
        value: '',
    },
    {
        label: '憎恨',
        value: '',
    },
    {
        label: '暴躁',
        value: '',
    },
    {
        label: '嫉妒',
        value: '',
    },
    {
        label: '沮丧',
        value: '',
    },
    {
        label: '苦恼',
        value: '',
    },
    {
        label: '厌恶',
        value: '',
    },
    {
        label: '火大',
        value: '',
    },
    {
        label: '敌对',
        value: '',
    },
    {
        label: '心烦',
        value: '',
    },
    {
        label: '释然',
        value: '',
    },
    {
        label: '平和',
        value: '',
    },
    {
        label: '安定',
        value: '',
    },
    {
        label: '专注',
        value: '',
    },
    {
        label: '沉静',
        value: '',
    },
    {
        label: '舒适',
        value: '',
    },
    {
        label: '平安',
        value: '',
    },
    {
        label: '放松',
        value: '',
    },
    {
        label: '释怀',
        value: '',
    },
    {
        label: '知足',
        value: '',
    },
    {
        label: '乐观',
        value: '',
    },
    {
        label: '接纳',
        value: '',
    },
    {
        label: '羞愧',
        value: '',
    },
    {
        label: '丢脸',
        value: '',
    },
    {
        label: '自卑',
        value: '',
    },
    {
        label: '孤独',
        value: '',
    },
    {
        label: '脆弱',
        value: '',
    },
    {
        label: '受伤',
        value: '',
    },
    {
        label: '无力',
        value: '',
    },
    {
        label: '无意义',
        value: '',
    },
    {
        label: '心碎',
        value: '',
    },
    {
        label: '绝望',
        value: '',
    },
    {
        label: '无助',
        value: '',
    },
    {
        label: '失望',
        value: '',
    },
]
export const CHAT_LIST = {
    scale: {
        title: '初步评估',
        tips: '点击进入评估内容',
        imgUrl: require('@/assets/images/preliminary-icon.png'),
        hrefUrl: '/survey'
    },
    problem_goal_motive: {
        title: '问题、目标与动机',
        tips: '点击进入评估内容',
        imgUrl: require('@/assets/images/goals-icon.png'),
        hrefUrl: '/problemGoalMotive'
    },
    mood_recognize_named: {
        title: '情绪识别',
        tips: '点击进入评估内容',
        imgUrl: require('@/assets/images/emotionalRecognition-icon.png'),
        hrefUrl: '/emotionalRecognition'
    },
    current_mood_score: {
        title: '当前情绪评分',
        tips: '点击进入评估内容',
        imgUrl: require('@/assets/images/currentEmotionalRating-icon.png'),
        hrefUrl: '/currentEmotionalRating'
    },
    twelve_mind_distort: {
        title: '思维陷阱',
        tips: '点击进入评估内容',
        imgUrl: require('@/assets/images/worksheet-icon.png'),
        hrefUrl: '/psychologicalDistortion'
    },
    auto_mindset_recognize: {
        title: '自动化思维识别',
        tips: '点击进入自动化思维识别',
        imgUrl: require('@/assets/images/automatedMindRecognition-icon.png'),
        hrefUrl: '/automatedMindRecognition'
    },
    cognize_reestablish: {
        title: '认知重建',
        tips: '点击进入认知重建',
        imgUrl: require('@/assets/images/automatedMindRecognition-icon.png'),
        hrefUrl: '/cognitiveReconstruction'
    },
    happly_exercise_list: {
        title: '愉悦活动清单',
        tips: '点击愉悦活动清单',
        imgUrl: require('@/assets/images/happlyActivityList-icon.png'),
        hrefUrl: '/happlyActivityList',
    },
    behaviour_exercise_plan: {
        title: '行为活动计划表',
        tips: '点击进入行为活动表',
        imgUrl: require('@/assets/images/behaviourExercisePlan-icon.png'),
        hrefUrl: '/behaviourExercisePlan',
        width: '76'
    },
    goal_progress: {
        title: '目标完成情况',
        tips: '点击进入评估内容',
        imgUrl: require('@/assets/images/goals-icon.png'),
        hrefUrl: '/goalCompletionStatus',
    },
    strategy_practice: {
        title: '对策卡游戏',
        tips: '点击进入对策卡游戏',
        imgUrl: require('@/assets/images/goals-icon.png'),
        hrefUrl: '/countermeasurecardDialogue',
    },
    case_study: {
        title: '案例练习',
        tips: '点击进入案例练习',
        imgUrl: require('@/assets/images/caseStudy-icon.png'),
        hrefUrl: '/caseStudy',
        width: '74'
    },
    therapy_calendar: {
        title: '治疗日历',
        tips: '点击进入治疗日历',
        imgUrl: require('@/assets/images/behaviourExercisePlan-icon.png'),
        hrefUrl: '/treatmentCalendar',
        width: '76'
    },
    schedule: {
        title: '活动量与情绪评分',
        tips: '点击进入活动量与情绪评分',
        imgUrl: require('@/assets/images/goals-icon.png'),
        hrefUrl: '/scaleReportMain',
    },
    relax_exercise: {
        title: '放松训练',
        tips: '点击进入放松训练',
        imgUrl: require('@/assets/images/goals-icon.png'),
        hrefUrl: '/relaxationTraining',
    },
    video: {
        title: '视频任务',
        tips: '点击播放视频',
        imgUrl: require('@/assets/images/goals-icon.png'),
        hrefUrl: 'videoPlay',
    },
}